export default __webpack_public_path__ + "static/base-dd3a2ebe7d3ac8c3e5157708431eec66.svg";